import TOCJourneyConfigURL from "@adapters/infrastructures/urlConfig/TOCJourney/TOCJourneyURL";
import AMOStatus from "@domains/features/TOCJourney/mapper/AMOStatusMapper";
import brokerChargesMapper from "@domains/features/TOCJourney/mapper/BrokerChargesMapper";
import CheckMarginMapper from "@domains/features/TOCJourney/mapper/CheckMarginMapper";
import { MultiQuoteMapper } from "@domains/features/TOCJourney/mapper/MultiQuoteMapper";
import orderDetailsMapper from "@domains/features/TOCJourney/mapper/orderDetailsMapper";
import placeNormalTradeMapper from "@domains/features/TOCJourney/mapper/placeNormalTrade";
import OfsTradeMapper from "@domains/features/TOCJourney/mapper/OfsTradeMapper";
export default class TOCJourney {
    constructor(http, accountDetails) {
        this.http = http;
        this.accountDetails = accountDetails;
    }
    async getIpoCancel(req) {
        const url = new URL(TOCJourneyConfigURL.ipoCancel);
        return await this.http.makeApiCall({
            method: "PUT",
            url: url.toString(),
            body: req,
        });
    }
    async getIpoOtpRegister(req) {
        const url = new URL(TOCJourneyConfigURL.ipoOtpRegister);
        return await this.http.makeApiCall({
            method: "POST",
            url: url.toString(),
            body: req,
        });
    }
    async getIpoOtpValidate(req) {
        const url = new URL(TOCJourneyConfigURL.ipoOtpValidate);
        return await this.http.makeApiCall({
            method: "POST",
            url: url.toString(),
            body: req,
        });
    }
    async getIpoBankMaster() {
        const url = new URL(TOCJourneyConfigURL.ipoBankMaster);
        return await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
        });
    }
    async getIpoOtpLeads(req) {
        const url = new URL(TOCJourneyConfigURL.ipoOtpLeads);
        return await this.http.makeApiCall({
            method: "POST",
            url: url.toString(),
            body: req,
        });
    }
    async mfPurchaseOrder(req) {
        const url = new URL(TOCJourneyConfigURL.mfPurchaseOrder +
            "/" +
            (await this.accountDetails.getUserID()));
        return await this.http.makeApiCall({
            method: "POST",
            url: url.toString(),
            body: req,
        });
    }
    async getMfSipStartDate(req) {
        const url = new URL(TOCJourneyConfigURL.mfStartDate);
        url.searchParams.append("isin", req.isin);
        url.searchParams.append("scmCd", req.scmCd);
        url.searchParams.append("amcCd", req.amcCd);
        url.searchParams.append("frq", req.frq);
        url.searchParams.append("gfot", req.gfot);
        url.searchParams.append("txnTyp", req.txnTyp);
        url.searchParams.append("mandateId", req.mandateId);
        return await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
        });
    }
    async getMfFrequency(req) {
        const url = new URL(TOCJourneyConfigURL.sipFrequency);
        url.searchParams.append("isin", req.isin);
        url.searchParams.append("scmCd", req.scmCd);
        url.searchParams.append("amcCd", req.amcCd);
        return await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
        });
    }
    async getMFPurchaseDetails(req) {
        const url = new URL(TOCJourneyConfigURL.MFPurchase);
        url.searchParams.append("isin", req.isin);
        url.searchParams.append("action", req.action);
        return await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
        });
    }
    async getNfoPurchaseDetails(req) {
        const url = new URL(TOCJourneyConfigURL.NfoPurchase);
        url.searchParams.append("isin", req.isin);
        url.searchParams.append("action", req.action);
        return await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
        });
    }
    async mfParticularHolding(req) {
        const url = new URL(`${TOCJourneyConfigURL.MFHolding}/${await this.accountDetails.getUserID()}/${req.isin}`);
        const result = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
        });
        return result.data;
    }
    async mfAllHoldings() {
        const url = new URL(`${TOCJourneyConfigURL.MFHolding}/${await this.accountDetails.getUserID()}`);
        const result = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
        });
        return result;
    }
    async getMultiQuoteDetails(reqObj) {
        const url = new URL(TOCJourneyConfigURL.multiquote);
        const multiQuotes = await this.http.makeApiCall({
            method: "POST",
            url: url.toString(),
            body: reqObj,
        });
        //const multiQuotes = JSON.parse(dummyMultiQuote);
        return MultiQuoteMapper(multiQuotes.data);
    }
    async placeNormalTrade(req) {
        const url = new URL(TOCJourneyConfigURL.placeNormalTrade + "/" + req.userID);
        const placeNormalTrade = await this.http.makeApiCall({
            method: "POST",
            url: url.toString(),
            body: req.body,
            // encryption: encryptionEnable,
        });
        return placeNormalTradeMapper(placeNormalTrade === null || placeNormalTrade === void 0 ? void 0 : placeNormalTrade.data);
    }
    async placeTradeComm(req) {
        const url = new URL(`${TOCJourneyConfigURL.placeTradeComm}/${req.userID}`);
        const placeTradeCommData = await this.http.makeApiCall({
            method: "POST",
            url: url.toString(),
            body: req.body,
            // encryption: encryptionEnable,
        });
        return placeNormalTradeMapper(placeTradeCommData === null || placeTradeCommData === void 0 ? void 0 : placeTradeCommData.data);
    }
    async placeAmoTrade(req) {
        const url = new URL(TOCJourneyConfigURL.amoTrade + "/" + req.userID);
        const placeNormalTrade = await this.http.makeApiCall({
            method: "POST",
            url: url.toString(),
            body: req.amoBody,
            // encryption: encryptionEnable,
        });
        return placeNormalTradeMapper(placeNormalTrade === null || placeNormalTrade === void 0 ? void 0 : placeNormalTrade.data);
    }
    async placeAmoTradeComm(req) {
        const url = new URL(TOCJourneyConfigURL.amoTradeComm + "/" + req.userID);
        const placeNormalTrade = await this.http.makeApiCall({
            method: "POST",
            url: url.toString(),
            body: req.amoBody,
            // encryption: encryptionEnable,
        });
        return placeNormalTradeMapper(placeNormalTrade === null || placeNormalTrade === void 0 ? void 0 : placeNormalTrade.data);
    }
    async placeBracketTrade(req) {
        const url = new URL(`${TOCJourneyConfigURL.bracketOrder}/${req.userID}`);
        const placeNormalTrade = await this.http.makeApiCall({
            method: "POST",
            url: url.toString(),
            body: req.bracketTradeBody,
            // encryption: encryptionEnable,
        });
        return placeNormalTradeMapper(placeNormalTrade === null || placeNormalTrade === void 0 ? void 0 : placeNormalTrade.data);
    }
    async placeEsipTrade(req) {
        const url = new URL(TOCJourneyConfigURL.esipOrder + "/" + req.userID);
        const placeNormalTrade = await this.http.makeApiCall({
            method: "POST",
            url: url.toString(),
            body: req.EsipBody,
            // encryption: encryptionEnable,
        });
        return placeNormalTradeMapper(placeNormalTrade === null || placeNormalTrade === void 0 ? void 0 : placeNormalTrade.data);
    }
    async placeOfsTrade(req) {
        const url = new URL(TOCJourneyConfigURL.PlaceOfsTrade + "/" + req.userID);
        const placeOFSTrade = await this.http.makeApiCall({
            method: "POST",
            url: url.toString(),
            body: req.body,
            // encryption: encryptionEnable,
        });
        return OfsTradeMapper(placeOFSTrade);
    }
    async orderDetails(req) {
        const url = new URL((req === null || req === void 0 ? void 0 : req.isComm)
            ? TOCJourneyConfigURL.orderDetailsComm + req.userID
            : TOCJourneyConfigURL.orderDetails + req.userID);
        url.searchParams.append((req === null || req === void 0 ? void 0 : req.isComm) ? "oID" : "nOID", req.orderID);
        const orderDetails = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
        });
        return orderDetailsMapper(orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.data);
    }
    async checkMargin(req) {
        const url = new URL(TOCJourneyConfigURL.checkMargin + "/" + req.userID);
        const checkMargin = await this.http.makeApiCall({
            method: "POST",
            url: url.toString(),
            body: req.reqBody,
            // encryption: encryptionEnable,
        });
        return CheckMarginMapper(checkMargin === null || checkMargin === void 0 ? void 0 : checkMargin.data);
    }
    async brokerCharge(req) {
        const url = new URL(TOCJourneyConfigURL.brokerCharges + "/" + req.userID);
        const brokerCharge = await this.http.makeApiCall({
            method: "POST",
            url: url.toString(),
            body: req.reqBody,
            // encryption: encryptionEnable,
        });
        return brokerChargesMapper(brokerCharge === null || brokerCharge === void 0 ? void 0 : brokerCharge.data);
    }
    async brokerChargeComm(req) {
        const url = new URL(TOCJourneyConfigURL.brokerChargesComm + "/" + req.userID);
        const brokerCharge = await this.http.makeApiCall({
            method: "POST",
            url: url.toString(),
            body: req.reqBody,
            // encryption: encryptionEnable,
        });
        return brokerChargesMapper(brokerCharge === null || brokerCharge === void 0 ? void 0 : brokerCharge.data);
    }
    async getRmsSublimits(userId) {
        const url = new URL(TOCJourneyConfigURL.rmsSubLimits + "/" + userId);
        const rmsSubLimits = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
        });
        return rmsSubLimits.data;
    }
    async getLimits(userId) {
        const url = new URL(TOCJourneyConfigURL.limits + "/" + userId);
        const limitsData = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
        });
        return limitsData.data;
    }
    async getRmsHoldingDetails(req) {
        const url = new URL(TOCJourneyConfigURL.rmsHolding + "/" + req.userId);
        url.searchParams.append("sym", req.symbol);
        const rmsholdings = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
        });
        return rmsholdings.data;
    }
    async getTpinData(req) {
        const url = new URL(TOCJourneyConfigURL.tpin);
        const tpinData = await this.http.makeApiCall({
            method: "POST",
            url: url.toString(),
            body: req,
            // encryption: encryptionEnable,
        });
        return tpinData.data;
    }
    async proceedToAuthorize(req) {
        const url = new URL(TOCJourneyConfigURL.authorize);
        const authorizeData = await this.http.makeApiCall({
            method: "POST",
            url: url.toString(),
            body: req,
            // encryption: encryptionEnable,
        });
        return authorizeData.data;
    }
    async AMOStatus(req) {
        let url;
        url =
            req.accType === "EQ"
                ? new URL(TOCJourneyConfigURL.eq + TOCJourneyConfigURL.amo + req.exchange)
                : new URL(TOCJourneyConfigURL.comm + TOCJourneyConfigURL.amo + req.exchange);
        const amoStatus = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
        });
        return AMOStatus(amoStatus === null || amoStatus === void 0 ? void 0 : amoStatus.data);
    }
    async cancelPlaceOrder(req) {
        var _a;
        let url;
        let userId = await ((_a = this.accountDetails) === null || _a === void 0 ? void 0 : _a.getUserID());
        url = req.isAmo
            ? new URL(TOCJourneyConfigURL.cancelAmoOrder + "/" + userId)
            : new URL(TOCJourneyConfigURL.cancelPlaceOrder + "/" + userId);
        const result = await this.http.makeApiCall({
            method: "PUT",
            url: url.toString(),
            body: { nstOID: req.orderId },
        });
        return result.data;
    }
    async cancelEsipOrder(req) {
        var _a;
        let url;
        let userId = await ((_a = this.accountDetails) === null || _a === void 0 ? void 0 : _a.getUserID());
        url = new URL(TOCJourneyConfigURL.cancelEsipOrder + "/" + userId);
        const result = await this.http.makeApiCall({
            method: "POST",
            url: url.toString(),
            body: { sipNum: req.orderId },
        });
        return result.data;
    }
    async modifyOrder(req) {
        let url;
        url = req.isAmo
            ? new URL(TOCJourneyConfigURL.modifyAmoOrder + "/" + req.userID)
            : new URL(TOCJourneyConfigURL.modifyOrder + "/" + req.userID);
        const result = await this.http.makeApiCall({
            method: "PUT",
            url: url.toString(),
            body: req.body,
        });
        return result.data;
    }
    async getUPIList(req) {
        const url = new URL(TOCJourneyConfigURL.upiList);
        const result = await this.http.makeApiCall({
            method: "POST",
            url: url.toString(),
            body: req,
        });
        return result.data;
    }
    async getSpecificIPODetails(req) {
        const url = new URL(TOCJourneyConfigURL.specificIPO);
        url.searchParams.append("co_code", req.co_code);
        const result = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
        });
        return result.data;
    }
    async applyIPO(req) {
        const url = new URL(TOCJourneyConfigURL.applyIPO);
        const result = await this.http.makeApiCall({
            method: "POST",
            url: url.toString(),
            body: req,
        });
        return result.data;
    }
    async getUserStatus(req) {
        const url = new URL(TOCJourneyConfigURL.userStatus);
        url.searchParams.append("pan", req.pan);
        url.searchParams.append("typ", req.typ);
        url.searchParams.append("val", String(req.val));
        const result = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
        });
        return result;
    }
}
